import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {WarehouseProduct} from "../../../shared/interface/warehouse-product";
import {MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {AuthService} from "../../../shared/services/auth.service";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {
  WarehouseProductPurchaseAddDialogComponent
} from "../warehouse-product-purchase-add-dialog/warehouse-product-purchase-add-dialog.component";
import {WarehouseService} from "../../../shared/services/warehouse.service";
import {first} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-warehouse-product-purchase-add',
  templateUrl: './warehouse-product-purchase-add.component.html',
  styleUrls: ['./warehouse-product-purchase-add.component.scss']
})
export class WarehouseProductPurchaseAddComponent implements OnInit, OnDestroy {
  @Input() warehouseProductObject: WarehouseProduct;
  @Input() dialogRef?: MatDialogRef<WarehouseProductPurchaseAddDialogComponent>;
  @Output() closeModification = new EventEmitter<any>();

  productPurchaseForm: FormGroup;
  processingRequest = false;
  errors: any = {};

  purchaseDateControl: FormControl;
  companyControl: FormControl;
  expirationDateControl: FormControl;
  amountControl: FormControl;
  warehouseProductControl: FormControl;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private formHelper: FormHelperService,
    private router: Router,
    private snackBar: MatSnackBar,
    private warehouseService: WarehouseService,
  ) {
    this.productPurchaseForm = fb.group({
      warehouseProduct: this.warehouseProductControl = fb.control(''),
      purchaseDate: this.purchaseDateControl = fb.control('', [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      expirationDate: this.expirationDateControl = fb.control(''),
      amount: this.amountControl = fb.control('', [Validators.required, Validators.min(0)]),
    });
  }

  ngOnInit(): void {
    this.warehouseProductControl.setValue(this.warehouseProductObject.uuid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    if (!this.productPurchaseForm.valid) {
      this.productPurchaseForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.processingRequest = true;

    if (this.formHelper && this.errors) {
      this.formHelper.removeBackendErrorState(this.productPurchaseForm, this.errors);
    }
    this.errors = {};

    const formData = this.productPurchaseForm.getRawValue();

    this.warehouseService.addProductPurchase(formData)
      .pipe(
        first()
      )
      .subscribe(
        (response: any) => {
          this.processingRequest = false;
          this.snackBar.open('Pomyślnie dodano dodatkową dostawę', '', {
            duration: 2000,
          });

          if (this.dialogRef) {
            this.dialogRef.close(true);
          } else {
            this.closeModification.emit();
          }
        },
        (error: HttpErrorResponse) => {
          this.processingRequest = false;

          this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status ? error.status.toString() : '', {
            duration: 2000,
          });

          if (error.status === 400 && error.error?.error?.list) {
            this.errors = error.error.error.list;
            this.formHelper.setBackendErrorState(this.productPurchaseForm, this.errors);
          }
        }
      );
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.closeModification.emit();
    }
  }
}
